import React from 'react';
import './walkthrough.css';

export default function WalkthroughControl(props) {
    return (
        <div className="siteTour__controls">
            {props.start && (
                <button className="siteTour__button button--start" onClick={props.onClickStart}>
                    Start
                </button>
            )}
            {props.prev && (
                <button
                    className="siteTour__button button--prev"
                    onClick={props.onClickPrev}
                >{`<< Prev`}</button>
            )}
            {props.skip && (
                <button className='siteTour__button button--skip' onClick={props.onClickSkip}>Skip</button>
            )
            }
            {props.next && (
                <button
                    className="siteTour__button button--next"
                    style={{ display: props.hideControls && 'none' }}
                    onClick={props.onClickNext}
                >{`Next >>`}</button>
            )}
            {props.end && (
                <button className="siteTour__button button--end" onClick={props.onClickEnd}>
                    Close
                </button>
            )}
        </div>
    );
}
